import { render, staticRenderFns } from "./authorization-oppo.vue?vue&type=template&id=3702e76f&scoped=true"
import script from "./authorization-oppo.vue?vue&type=script&lang=ts"
export * from "./authorization-oppo.vue?vue&type=script&lang=ts"
import style0 from "./authorization-oppo.vue?vue&type=style&index=0&id=3702e76f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3702e76f",
  null
  
)

export default component.exports